export default __webpack_public_path__ + "static/media/Snd_C5.f96b993e.mp3";